module.exports = __webpack_public_path__ + "static/media/trophy-his-bg.533f7410.png";